<template>
<v-container fluid>
    <v-row>
        <ActionDropdown 
            :items="actions"
            :context="context"
            :alvqa="alvqa"
        />
        <div class="d-flex align-center" style="margin-left: -8px;">
            <ContextHelpIcon 
                v-if="hasActionsContextHelp"
                context="PublishingStatementsListActions"
                :alvqa="alvqa + '-actions-context-help-icon'"
            />
        </div>
        <v-col 
            cols="2"
            align-self="center"
            class="d-flex align-center"
            style="margin-left: 15px;"
        >
            <BaseDropdown
                :items="reportDropdownItems"
                :label="$t('lang_GENERIC_ACTION_BULK_FILE_IMPORT_REPORT')"
                :context="context+'ReportDropdown'"
                :hideDetails="true"
                :returnObject="false"
                :clearable="false"
                :resetOnSelect="true"
                :outlined="true"
                :alvqa="alvqa + '-list-report-dropdown'"
            />
            <ContextHelpIcon 
                v-if="hasContextHelp"
                context="PublishingStatementsReports"
                :alvqa="alvqa + '-reports-context-help-icon'"
                class="ml-2"
            />
        </v-col>
        <v-col 
            align-self="center"
            class="v-label theme--light mt-3"
        >
            <BaseHeaderStats 
                context="PublishingStatements" 
                typeStats="LIST"
                :alvqa="alvqa + '-list'"
            />
        </v-col>
        <v-col 
            v-if="$store.getters.getIsPublishingStatementsRunning"
            cols="2"
            align-self="center"
            class="mt-2 text-right"
        >
            <BaseButton 
                label="lang_GENERIC_BUTTON_CAPTION_CHECK_STATUS"
                block
                @click="checkStatus()"
                :alvqa="alvqa + '-list-button-check-statement-status'"
            />
        </v-col>
    </v-row>
    <PublishingStatementsBankFileDialog />
    <PublishingStatementsJournalDialog />
</v-container>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseDropdown from '@/components/_base/BaseDropdown'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'
import PublishingStatementsBankFileDialog from './_dialogs/PublishingStatementsBankFileDialog'
import PublishingStatementsJournalDialog from './_dialogs/PublishingStatementsJournalDialog'

export default {
    name: "PublishingStatementsTopSlot",
    components: {
        ActionDropdown,
        BaseHeaderStats,
        BaseButton,
        BaseDropdown,
        ContextHelpIcon,
        PublishingStatementsBankFileDialog,
        PublishingStatementsJournalDialog,
    },
    data() {
        return {
            context: "PublishingStatements",
            alvqa: "publishing-statements",
            royaltyControlLingBtnLabel:'',
            royaltyControlLingBtnDisabled:false,
            hasContextHelp: false,
            hasActionsContextHelp: false,
        }
    },
    computed: {	
        totalRecords() { return this.$store.getters.getTotalRecords },

        royaltyControllingIsRunning: {
            get() { return this.$store.getters.getPublishingStatementsRoyaltyControllingInProcess },
            set(status) { this.$store.commit('setPublishingStatementsRoyaltyControllingInProcess', status) }
        },
        royaltyControllingPath: {
            get() { return this.$store.getters.getPublishingStatementsRoyaltyControllingPath },
            set(path) { this.$store.commit('setPublishingStatementsRoyaltyControllingPath', path) }
        },
        getRoyaltyControllingBtnLabel(){
            let royaltyControlLingBtnLabel = this.$t('lang_PUBLISHING_STATEMENTS_BUTTON_OPTION_ROYALTY_CONTROLLING')

            if(this.royaltyControllingIsRunning){
                royaltyControlLingBtnLabel = this.$t("lang_PUBLISHING_STATEMENTS_ROYALTY_CONTROLLING_POPUP")
            }
            // Download is now handled via Ably notifications in Dashboard

            return royaltyControlLingBtnLabel
        },
        reportDropdownItems() {
            let items = [
                { 
                    text: this.getRoyaltyControllingBtnLabel, 
                    value: 'royaltyControlling', 
                    alvqa: this.alvqa + '-list-report-dropdown-royalty-controlling',
                    disabled: this.royaltyControllingIsRunning
                },
                {
                    text: this.$t('lang_PUBLISHING_STATEMENTS_CAPTION_JOURNAL'),
                    value: 'journal',
                    alvqa: this.alvqa + '-list-report-dropdown-journal',
                    disabled: this.$store.getters.getPublishingStatementsJournalInProcess
                },
                {
                    text: this.$t('lang_PUBLISHING_STATEMENTS_CAPTION_FAKTURA_DATEV'),
                    value: 'faktura',
                    alvqa: this.alvqa + '-list-report-dropdown-faktura',
                    disabled: this.$store.getters.getPublishingStatementsFakturaInProcess
                },
                {
                    text: this.$t('lang_PUBLISHING_STATEMENTS_CAPTION_GENERATE_BANK_FILE'),
                    value: 'generateBankFile',
                    alvqa: this.alvqa + '-list-report-dropdown-generate-bank-file'
                }
            ]

            return items
        },
        actions() {
            return [ 
                {
                    text: this.$t('lang_GENERIC_ACTION_OPTION_CAPTION_LAUNCH_STATEMENT_PREVIEW'), 
                    value: 'launchStatementRun',
                    alvqa: this.alvqa + '-list-action-dropdown-run-statements'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_ARCHIVE_WITH_CARRY_FORWARD"),
                    value: 'archiveWithForwarded',
                    alvqa: this.alvqa + '-list-action-dropdown-archive-with-forwarded'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_ARCHIVE_WITHOUT_CARRY_FORWARD"),
                    value: 'archiveWithoutForwarded',
                    alvqa: this.alvqa + '-list-action-dropdown-archive-without-forwarded'
                },
                {
                    text: this.$t('lang_PUBLISHING_STATEMENTS_CAPTION_DOWNLOAD_BULK'), 
                    value: 'bulkDownload',
                    alvqa: this.alvqa + '-list-action-dropdown-bulk-download'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ASSIGN_MAPPINGS'),
                    value: 'assignTemplates',
                    alvqa: this.alvqa + '-list-action-dropdown-assign-templates'
                }
            ]
        },        
    },
    methods: {
        checkStatus() {
            this.$store.dispatch('checkStatusOfStatementsRun', {context: 'PublishingStatements', dir: 'publishing/statements'})
        },
    },
    async created() {
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('PublishingStatementsReports')
        this.hasActionsContextHelp = await this.$alvPlugin.checkContextHelpAvailability('PublishingStatementsListActions')
    }
}
</script>